export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_USERS = 'SET_USERS'